import * as React from "react";
import { connect } from "react-redux";
import IBookmarkState from "./interfaces/bookmarkState";
import IBookmarkCategoriesProps from "./interfaces/bookmarkCategoriesProps";
import { actionCreators } from "./redux/actions";
import BookmarkList from "./bookmarkList";
import { handleHideSideBarSubLevel } from "../../modules/sidebar";

class BookmarkCategories extends React.Component<
  IBookmarkCategoriesProps,
  IBookmarkState
> {
  container: any;
    dialogRef: React.RefObject<HTMLDivElement>;
    previouslyFocusedElement: HTMLElement | null = null;

    constructor(props) {
        super(props);
        this.dialogRef = React.createRef<HTMLDivElement>();
    }

    // Focus trap
    handleFocusTrap = (e: KeyboardEvent) => {
        if (e.key !== "Tab" || !this.dialogRef.current) return;

        const focusableSelectors =
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

        const focusable = Array.from(
            this.dialogRef.current.querySelectorAll<HTMLElement>(focusableSelectors)
        ).filter(el => el.offsetParent !== null);

        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        }
    };

    componentDidUpdate(prevProps) {
        const dialogOpened =
            this.props.activeTab === "edit-categories" &&
            prevProps.activeTab !== "edit-categories";
        const dialogClosed =
            this.props.activeTab !== "edit-categories" &&
            prevProps.activeTab === "edit-categories";

        if (dialogOpened) this.openDialog();
        if (dialogClosed) this.closeDialog();
    }

    openDialog() {
        this.previouslyFocusedElement = document.activeElement as HTMLElement;
        document.addEventListener("keydown", this.handleFocusTrap);

        // Vänta tills DOM har renderat close-knappen
        setTimeout(() => {
            const closeBtn = this.dialogRef.current?.querySelector<HTMLButtonElement>(
                ".closeButton"
            );
            closeBtn?.focus();
        }, 0);
    }

    closeDialog() {
        document.removeEventListener("keydown", this.handleFocusTrap);
        this.previouslyFocusedElement?.focus();
    }

    toggleEditModal = (e: React.MouseEvent | React.KeyboardEvent, categoryId: number) => {
        e.stopPropagation();
        alert(`Redigera kategori ${categoryId}`);
    };
  render() {
    const examModeContainer = document.getElementById("exam-mode-container");
    let examModeContent: string | null = null;

    if (examModeContainer && !examModeContainer.classList.contains("exam-mode-container_consultant")) {
        examModeContent = examModeContainer.innerHTML;
    }

    return (
      <div
        className="pIFavorites personal__subnavigation  personal__subnavigation--flex  personal__subnavigation--expanded bookmarkSubmenu"
        id="js-react-bookmarks-expanded"
        >
        <div className="coverages__tabs-container">
          <div
            tabIndex={0}
            aria-label="Redigera favoriter"
            className={`coverages__tab-categories dotsIcon ${
              this.props.activeTab === "edit-categories"
                ? "coverages__tab--active"
                : ""
            }`}
            onKeyDown={(e)=>{
                if (e.key === "Enter" && e.target === e.currentTarget) {
                    this.props.setActiveBookmarkerTab("edit-categories");
                    setTimeout(() => { $(".semiModal").find(".closeButton").focus() }, 50);
                }
            }}
            onClick={() => {
              this.props.setActiveBookmarkerTab("edit-categories");
            }}
          >
          </div>

          <div
            className={`coverages__tab  ${
              this.props.activeTab === "listed-categories"
                ? "coverages__tab--active"
                : ""
            }`}
            tabIndex={0}
            onKeyUp={(e)=>{
              e.key==="Enter"&& this.props.setActiveBookmarkerTab("listed-categories");
            }}
            onClick={() => {
              this.props.setActiveBookmarkerTab("listed-categories");
            }}
          >
            <div className="coverages__tab-title">Dokument</div>
            <div
              className={`coverages__tab-marker  ${
                this.props.activeTab === "listed-categories"
                  ? "coverages__tab-marker--active"
                  : ""
              }`}
            >
            </div>
          </div>

          <div
            className={`coverages__tab  ${this.props.activeTab === "listed-courses-categories"
                ? "coverages__tab--active"
                : ""
            }`}
            tabIndex={0}
            onKeyUp={(e) => {
                e.key === "Enter" && this.props.setActiveBookmarkerTab("listed-courses-categories");
            }}
            onClick={() => {
                this.props.setActiveBookmarkerTab("listed-courses-categories");
            }}
           >
            <div className="coverages__tab-title">Kurser</div>
            <div
                className={`coverages__tab-marker  ${this.props.activeTab === "listed-courses-categories"
                    ? "coverages__tab-marker--active"
                    : ""
                }`}
            ></div>
          </div>
        </div>

        {examModeContent && (
            <div
                dangerouslySetInnerHTML={{ __html: examModeContent }}
            />
        )}
            {!examModeContent && (
                <div
                    id="favouritesList"
                    className={`coverages__list-wrapper ${this.props.activeTab === "edit-categories"
                        ? "active semiModal"
                        : ""
                        }`}
                    ref={this.dialogRef}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="dialog-title"
                >
                    <div className="">
                        {this.props.activeTab === "edit-categories"
                            ? <>
                                <div className="coverages__header reverseHeader">
                                    <strong id="dialog-title">Favoritkategorier</strong>
                                    <button
                                        className="closeButton"
                                        aria-label="Stäng favoritkategorier"
                                        onClick={(e) => {
                                            e.stopPropagation(); // <-- stoppa att Enter bubblar upp
                                            this.props.setActiveBookmarkerTab("listed-categories");
                                        }}>
                                        <span>Stäng</span></button>
                                </div>
                            </> : <></>}
                        {this.props.noContentMessage &&
                            this.props.activeTab !== "edit-categories" ? (
                            <div className="bookmarks__list-item bookmarks__list-item--padding-y">
                                {this.props.noContentMessage}
                            </div>
                        ) : null}
                        {this.props.bookmarks.length > 0 ||
                            this.props.activeTab === "edit-categories" ? (
                                <BookmarkList
                                    bookmarks={this.props.bookmarks}
                                    toggleEditModal={this.toggleEditModal}
                                />
                        ) : null}
                    </div>
                </div>
            )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps): IBookmarkCategoriesProps => {
  return {
    ...ownProps,
    setActiveBookmarkerTab: (tabName) => {
      dispatch(actionCreators.setActiveBookmarkerTab(tabName));
    },
  };
};

const mapStateToProps = (
  state: IBookmarkState,
  props: IBookmarkCategoriesProps
): IBookmarkCategoriesProps => {
  return {
    noContentMessage: state.noContentMessage,
    bookmarks: state.bookmarks,
    activeTab: state.activeTab,
    setActiveBookmarkerTab: props.setActiveBookmarkerTab,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BookmarkCategories);
